import { Action, Store } from '@ngrx/store';

export abstract class StoreFacade {
  constructor(protected store: Store) {}

  dispatch(action: Action): void {
    this.store.dispatch(action);
  }
}
